// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file gitpod/v1/session.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AddSessionResourceRequest, AddSessionResourceResponse, CreateSessionRequest, CreateSessionResponse, DeleteSessionRequest, DeleteSessionResponse, GetSessionRequest, GetSessionResponse, ListSessionResourcesRequest, ListSessionResourcesResponse, ListSessionsRequest, ListSessionsResponse, RemoveSessionResourceRequest, RemoveSessionResourceResponse, UpdateSessionRequest, UpdateSessionResourceRequest, UpdateSessionResourceResponse, UpdateSessionResponse } from "./session_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service gitpod.v1.SessionService
 */
export const SessionService = {
  typeName: "gitpod.v1.SessionService",
  methods: {
    /**
     * @generated from rpc gitpod.v1.SessionService.CreateSession
     */
    createSession: {
      name: "CreateSession",
      I: CreateSessionRequest,
      O: CreateSessionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gitpod.v1.SessionService.GetSession
     */
    getSession: {
      name: "GetSession",
      I: GetSessionRequest,
      O: GetSessionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gitpod.v1.SessionService.ListSessions
     */
    listSessions: {
      name: "ListSessions",
      I: ListSessionsRequest,
      O: ListSessionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gitpod.v1.SessionService.UpdateSession
     */
    updateSession: {
      name: "UpdateSession",
      I: UpdateSessionRequest,
      O: UpdateSessionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gitpod.v1.SessionService.DeleteSession
     */
    deleteSession: {
      name: "DeleteSession",
      I: DeleteSessionRequest,
      O: DeleteSessionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gitpod.v1.SessionService.AddSessionResource
     */
    addSessionResource: {
      name: "AddSessionResource",
      I: AddSessionResourceRequest,
      O: AddSessionResourceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gitpod.v1.SessionService.RemoveSessionResource
     */
    removeSessionResource: {
      name: "RemoveSessionResource",
      I: RemoveSessionResourceRequest,
      O: RemoveSessionResourceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gitpod.v1.SessionService.UpdateSessionResource
     */
    updateSessionResource: {
      name: "UpdateSessionResource",
      I: UpdateSessionResourceRequest,
      O: UpdateSessionResourceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gitpod.v1.SessionService.ListSessionResources
     */
    listSessionResources: {
      name: "ListSessionResources",
      I: ListSessionResourcesRequest,
      O: ListSessionResourcesResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

